import { render, staticRenderFns } from "./DataRuleList.vue?vue&type=template&id=5440f340"
import script from "./DataRuleList.vue?vue&type=script&lang=js"
export * from "./DataRuleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5440f340')) {
      api.createRecord('5440f340', component.options)
    } else {
      api.reload('5440f340', component.options)
    }
    module.hot.accept("./DataRuleList.vue?vue&type=template&id=5440f340", function () {
      api.rerender('5440f340', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/sys/menu/DataRuleList.vue"
export default component.exports